var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量审核记录",
        visible: _vm.dialog.visible,
        width: "1000px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.dialog, "visible", $event)
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "record-query" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, size: "small" } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "审核状态", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.auditStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "auditStatus", $$v)
                        },
                        expression: "query.auditStatus",
                      },
                    },
                    _vm._l(_vm.auditStatusDict, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialog.loading,
              expression: "dialog.loading",
            },
          ],
          attrs: {
            data: _vm.table.bodys,
            stripe: "",
            border: "",
            "max-height": "520px",
            "row-key": "id",
          },
        },
        [
          _c("el-table-column", {
            attrs: { type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: row.items || [],
                          size: "mini",
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "资源位code",
                            prop: "code",
                            "min-width": "140",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "标题",
                            prop: "title",
                            "min-width": "140",
                            align: "center",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作类型",
                            prop: "operationName",
                            width: "120",
                            align: "center",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "审批实例号",
              prop: "instanceCode",
              "min-width": "180",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "资源位数量",
              prop: "itemCount",
              width: "100",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "审核状态",
              prop: "auditStatusName",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getAuditStatusTagType(row.auditStatus),
                          size: "mini",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.auditStatusName) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "提交人",
              prop: "submitter",
              width: "110",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "提交时间",
              prop: "createTime",
              width: "160",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "100",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.auditStatus === _vm.AUDIT_STATUS_PENDING
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCancel(row)
                              },
                            },
                          },
                          [_vm._v("撤销")]
                        )
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "record-pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next",
              total: _vm.page.total,
              "current-page": _vm.page.current,
              "page-size": _vm.page.size,
              "page-sizes": [10, 20, 50],
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }